import { Component, Input, EventEmitter, Output } from '@angular/core';
import { IUProperty } from '../../interface/umbraco-property';

export interface IModalVideo {
  video: any;
  params?: string;
}
@Component({
  selector: 'app-bg-modal-video',
  templateUrl: './bg-modal-video.component.html',
  styleUrls: ['./bg-modal-video.component.less']
})
export class BGModalVideoComponent {
  @Input() data: IModalVideo;
  @Input() isShow: boolean = false;
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() { }

  readonly UMEDIA_TYPE: number = 2;

  handleClose(): void {
    return this.close.emit(null);
  }
}
